import { size } from 'lodash';
import React, { Fragment } from 'react';

const BeforeDrivingList = ({ city = 'toronto' }) => (
  <Fragment>
    <p>
      Before you drive, you will need to complete the pre-booking
      experience:
    </p>
    <ol>
      <li>
        <strong>Check what the battery level is.</strong>
        <ol style={{ listStyleType: 'lower-alpha' }}>
          <li>
            If the battery % is too low to complete your booking, head to
            the nearest Tesla Supercharger to charge your vehicle for 20-60
            minutes.
          </li>
        </ol>
      </li>
      <br />
      <li>
        <strong>
          Take photos of all 6 sides of the vehicle to report its condition
          upon pickup.
        </strong>
        <ol style={{ listStyleType: 'lower-alpha' }}>
          <li>
            Tap each camera icon to capture photos of each side of the car.
            You can move the vehicle out from its parking spot if there is
            not enough room for you (EV drivers have 2 minutes to complete
            this process before the vehicle’s motor turns off). If you
            start your booking without completing this step, you will be
            liable for any new damages found upon inspection.
          </li>
        </ol>
      </li>
      <br />
      <li>
        <strong>Confirm that the vehicle is safe to drive.</strong>
        <ol style={{ listStyleType: 'lower-alpha' }}>
          <li>
            With the vehicle on, confirm that no warning lights appear on
            the dashboard or central display. If there are no issues with
            the vehicle, you can select “Yes” to accept that the vehicle is
            safe and proceed to the last step of the pre-booking
            inspection.
          </li>
          <li>
            If the vehicle is not safe to drive, (warning lights appear,
            flat tire, etc) you will need to select “No”, take a photo(s)
            of the error message/issue, and include details of any issues
            with the vehicle. Once you have submitted why the vehicle is
            not safe to drive, you will be given the option to request
            another vehicle. Lock the current vehicle before switching to
            the new vehicle, and restart the pre-booking inspection
            process.
          </li>
        </ol>
      </li>
      <br />
      <li>
        <strong>Confirm the cleanliness of the vehicle.</strong>
        <ol style={{ listStyleType: 'lower-alpha' }}>
          <li>
            The app will ask you to confirm the cleanliness of the vehicle.
            If you select 3 - 5 stars, and are happy with the condition of
            the vehicle, your pre-booking inspection process will be
            completed and you can start your booking.
          </li>
          <li>
            If you confirm that the car is dirty (2 stars) or very dirty (1
            star), take a photo(s) of the vehicle’s condition including
            details. Once submitted, you will be able to request to be
            switched to another vehicle. If you switch to another vehicle,
            you will need to restart the whole pre-booking inspection
            process again.
          </li>
        </ol>
      </li>
      <br />
      <div>
        *Any false reports made about the current condition of the vehicle
        will result in a $30 penalty fee charged to your account or account
        suspension.
      </div>
      <br />
      <li>
        <strong>
          Select the correct license plate in the Uber Driver app.
        </strong>
        <ol style={{ listStyleType: 'lower-alpha' }}>
          <li>
            Once you have submitted your pre-booking inspection, the
            vehicle that you are assigned to will populate at the top of
            your vehicle’s list in the Uber Driver app. You must select the
            correct license plate in the Uber Driver app to match the Autzu
            vehicle you are driving.
          </li>
          <li>
            This is <u>most important for insurance purposes</u> and also
            allows your riders to correctly locate your vehicle
            make/model/plate/color when you arrive at a pickup location.
          </li>
        </ol>
      </li>
      <br />
    </ol>
  </Fragment>
);

export default BeforeDrivingList;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/StartYourBooking/BeforeDrivingList.js